import { array } from '@mojotech/json-type-validation'

import { TestCaseRepository } from '@/domain/repositories/testCase/TestCaseRepository'
import { TestCase } from '@/domain/value_objects/testCase/TestCase'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { testCaseDecoder } from '@/infrastructure/decoders/testCase/testCaseDecoder'

export class TestCaseRepositoryImpl implements TestCaseRepository {
  constructor(private clients: ApiClients) {}

  async getTestCaseList(problemId: string): Promise<TestCase[]> {
    const path = `testcases/samples/${problemId}`
    const data = await this.clients.datClient.fetchAndDecode(array(testCaseDecoder), path)
    return data
  }

  async getJudgeCaseList(problemId: string): Promise<TestCase[]> {
    const judgeCaseList: TestCase[] = []

    const header = await this.getJudgeCaseListHeader(problemId)
    const judgeCaseListSize = header.headers.length

    for (let i = 0; i < judgeCaseListSize; i++) {
      let newJudgeCase: TestCase = {
        in: "It's large data. Please download it.",
        out: "It's large data. Please download it.",
        problemId: problemId,
        serial: i + 1
      }

      const INPUT_SIZE = header.headers[i].inputSize
      const OUTPUT_SIZE = header.headers[i].outputSize

      if (INPUT_SIZE <= 1000 && OUTPUT_SIZE <= 1000 && i + 1 <= judgeCaseListSize) {
        const path = `testcases/${problemId}/${i + 1}`
        newJudgeCase = await this.clients.datClient.fetchAndDecode(testCaseDecoder, path)
        newJudgeCase.in = newJudgeCase.in === 'NO input\n' ? '' : newJudgeCase.in
        newJudgeCase.in = newJudgeCase.in === 'empty\n' ? '' : newJudgeCase.in
      }
      judgeCaseList.push(newJudgeCase)
    }
    return judgeCaseList
  }

  async getJudgeCaseListHeader(problemId: string): Promise<any> {
    const path = `testcases/${problemId}/header`
    const data = await this.clients.datClient.fetch(path)
    return data
  }
}
